// import css from "./Logo.module.css"

const Logo = () => {
    return (
<img src="/RentalCar.svg" alt="Logo" />
     
    );
};

export default Logo;